export enum Priority {
   Solved = 0, // Green
   Low = 1, // Blue
   Medium = 2, // Yellow
   High = 3, // Orange
   Urgent = 4, // Red,
   All = 5,
}
